import MapSight from "./mapsight/Map.js"
// import React, { useRef, useEffect, useState } from "react";
import React from "react";
import mapboxgl from "mapbox-gl";

import Legend from "./components/Legend";
import Optionsfield from "./components/Optionsfield";
import MapSelector from "./components/mapSelector";
import "./Map.css";
// // import Tooltip from "./components/Tooltip";
// import HeatTooltip from "./components/tooltips/HeatTooltip";
// import ReactDOM from "react-dom";

// import configData from "./config.json";
// import { TableHeader } from "semantic-ui-react";

mapboxgl.accessToken =
  "pk.eyJ1IjoiZ2VvaW5zaWdodG56IiwiYSI6ImNrb3hybzJ2bTA0Z3cycHRhMG16Y2hzb2EifQ.Q_6eShFAXIFPa_rt_Pa5bw";

class Map extends MapSight {
 
  
 
   generateControl(control, i) {

    let classes = "absolute m12";
    if (control.hasOwnProperty("position")) {
      control.position.map(arg => {
        classes = classes + " " + arg;
        // if(arg === "bottom") {
        //   classes = "absolute " + classes;
        // }
        return classes;
      });
    }

    switch (control.type) {

      case "legend":
        if (typeof this.state.activeStyle.labels !== 'undefined') {


          return (
            <div key={control.id} className={classes}>
              <Legend
                active={this.state.activeStyle}
                labels={this.state.activeStyle.labels}
              />
            </div>
          );
        }
        break;

      case "options":
        return (
          <div key={control.id} className={classes}>
            <Optionsfield
              options={this.styleOptions}
              property={this.state.activeStyle.id}
              changeState={this.changeStyleState}
            />
          </div>
        );

      case "maptiles":
        return (
          <div key={control.id} className={classes}>
            <MapSelector
              options={this.mapTypes}
              property={this.state.activeMapStyle.mapStyle}
              changeState={this.changeMapState}
            />
          </div>
        );

      default:
        return <></>;
    }
  }
 
}

export default Map;
